import { render, staticRenderFns } from "./create-campaign-dialog-flow-rule.vue?vue&type=template&id=6b1d1492&scoped=true&"
import script from "./create-campaign-dialog-flow-rule.vue?vue&type=script&lang=ts&"
export * from "./create-campaign-dialog-flow-rule.vue?vue&type=script&lang=ts&"
import style0 from "./create-campaign-dialog-flow-rule.vue?vue&type=style&index=0&id=6b1d1492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d1492",
  null
  
)

export default component.exports